import { useMemo } from 'react';
import { useGetConversationByIdQuery } from 'src/store/services';
import { useAppSelector, sessionState } from 'src/store';
import { useConversationParams } from './useConversationParams';

export const useCurrentConversationMessageList = (
  conversationId?: string | null,
) => {
  const {
    appUser: { user_id },
  } = useAppSelector(sessionState);

  const { currentConversationId, shouldSkipGetConversationById } =
    useConversationParams(conversationId);

  const { messages: conversationMessages } = useGetConversationByIdQuery(
    {
      user_id,
      conversation_id: conversationId || currentConversationId,
    },
    {
      skip: shouldSkipGetConversationById,
      selectFromResult: (result) => {
        return { messages: result.data?.messages || [] };
      },
    },
  );

  return useMemo(
    () => ({
      messageListLength: conversationMessages.length,
    }),
    [conversationMessages.length],
  );
};
